import axiosAPI from '../../utils/client/axiosAPI';
import {
  ActivityLogResponse,
  ActivityLogCauserResponse,
  ActivityLogQueryParams,
  ActivityLogType,
  ActivityLogEvent
} from './contracts';

/**
 * The ActivityLog class provides a structured way to interact with activity log data.
 */
export class ActivityLog {
  public readonly id: number;
  public readonly logName: ActivityLogType;
  public readonly description: string;
  public readonly event: ActivityLogEvent;
  public readonly subjectType: string;
  public readonly subjectId: number;
  public readonly causer: ActivityLogCauserResponse | null;
  public readonly createdAt: Date;

  constructor(data: ActivityLogResponse) {
    this.id = data.id;
    this.logName = data.log_name;
    this.description = data.description;
    this.event = data.event;
    this.subjectType = data.subject_type;
    this.subjectId = data.subject_id;
    this.causer = data.causer;
    this.createdAt = new Date(data.created_at);
  }

  /**
   * Fetches a list of activity log entries from the API.
   * @param params - Optional query parameters for pagination.
   * @returns A promise that resolves to an array of ActivityLog instances.
   */
  public static async get(
    params: ActivityLogQueryParams = {}
  ): Promise<ActivityLog[]> {
    const { data } = await axiosAPI.get<ActivityLogResponse[]>(
      'admin/activity-log',
      {
        params,
        signal: params.controller?.signal
      }
    );
    return data.map((activity) => new ActivityLog(activity));
  }
}
